import { render, staticRenderFns } from "./GestioneAssembly.vue?vue&type=template&id=0d2f4602&"
import script from "./GestioneAssembly.vue?vue&type=script&lang=js&"
export * from "./GestioneAssembly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports